// extracted by mini-css-extract-plugin
export default {"Loader":"Loader_Loader__P87Wq","spin":"Loader_spin__uQpQW"};